import type { OpportunityView, OpportunityViewParams } from '../services/opportunity-navigation.state';

const DEBUG_FLAG = 'opportunityWorkflowDebug';

/** Enable with `localStorage.setItem('opportunityWorkflowDebug', '1')` in devtools. */
export function isOpportunityWorkflowDebugEnabled(): boolean {
  try {
    return globalThis.localStorage?.getItem(DEBUG_FLAG) === '1';
  } catch {
    return false;
  }
}

export function logOpportunityWorkflowDebug(
  stage: string,
  payload: Record<string, unknown>,
): void {
  if (!isOpportunityWorkflowDebugEnabled()) {
    return;
  }
  console.groupCollapsed(`[OpportunityWorkflow] ${stage}`);
  console.log(payload);
  console.groupEnd();
}

export function logOpportunityNavTransition(input: {
  stage: string;
  pausedNodeKey?: string | null;
  pausedNodeType?: string | null;
  pausedNodeLabel?: string | null;
  pausedNodeMode?: string | null;
  context?: Record<string, unknown>;
  resolutionView?: OpportunityView | null;
  resolutionParams?: Partial<OpportunityViewParams>;
  finalView?: OpportunityView;
  finalParams?: OpportunityViewParams;
}): void {
  if (!isOpportunityWorkflowDebugEnabled()) {
    return;
  }

  const ctx = input.context ?? {};
  logOpportunityWorkflowDebug(input.stage, {
    pausedNode: {
      key: input.pausedNodeKey ?? null,
      type: input.pausedNodeType ?? null,
      label: input.pausedNodeLabel ?? null,
      mode: input.pausedNodeMode ?? null,
    },
    context: {
      opportunityId: ctx['opportunityId'] ?? ctx['opportunityID'] ?? null,
      id: ctx['id'] ?? null,
      partyId: ctx['partyId'] ?? null,
      customerId: ctx['customerId'] ?? null,
      applicantType: ctx['applicantType'] ?? ctx['applicantTypes'] ?? null,
      applicantStatus: ctx['applicantStatus'] ?? ctx['statusOptions'] ?? null,
      actionKey: ctx['actionKey'] ?? null,
      wfStep: ctx['wfStep'] ?? null,
    },
    resolution: {
      view: input.resolutionView ?? null,
      params: input.resolutionParams ?? null,
    },
    navigation: {
      view: input.finalView ?? null,
      params: input.finalParams ?? null,
    },
  });
}
